import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  CategoryLabelProvider,
  Heading,
  LabelType,
  useProductBrowser,
} from '@techstyle/react-components';

import { mobile } from '../../styles';

export const ActiveCategoryLabel = styled(Heading)`
  flex: 1;
  font-size: 24px;
  font-weight: 300;
  letter-spacing: ${0.4 / 24}em;

  ${mobile`
    ${({ isBuilder }) => isBuilder && `display: none;`}
  `}
`;

function ActiveCategoryHeading({ isBuilder = false }) {
  const { activeCategory } = useProductBrowser();
  const categoryLabels = CategoryLabelProvider.useLabels();

  return (
    <ActiveCategoryLabel level={1} isBuilder={isBuilder}>
      {categoryLabels.renderLabel(activeCategory, {
        isTopLevel: activeCategory.isTopLevel,
        labelType: LabelType.TOP_LEVEL_CATEGORY_HEADING,
      })}
    </ActiveCategoryLabel>
  );
}

ActiveCategoryHeading.propTypes = { isBuilder: PropTypes.bool };

export default ActiveCategoryHeading;
